import React from "react";
import "./App.css";
import Container from "./components/Container";
// import Logger from "./components/Logger";

function App() {
  return (
    <div className="App">
      <title>CYNTHIA DONG</title>
      {/* <Logger></Logger> */}
      <Container></Container>
    </div>
  );
}

export default App;
